// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ppR2","clinicsSelect":"styles_clinicsSelect__3LU6r"};